import React, { ReactNode } from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface QuestionMarkProps {
    children: ReactNode; // Tooltip content
    className?: string; // Optional additional class names
    style?: React.CSSProperties; // Optional additional styles
}

export const QuestionMark: React.FC<QuestionMarkProps> = ({ children, className = '', style = {} }) => {
    return (
        <Tooltip title={children}>
            <QuestionCircleOutlined
                className={`ml-2 ${className}`}
                style={{ cursor: 'pointer', fontSize: 14, color: '#D92923', ...style }}
            />
        </Tooltip>
    );
};
